import { render, staticRenderFns } from "./integral-goods-review.vue?vue&type=template&id=cf70f35c&"
import script from "./integral-goods-review.vue?vue&type=script&lang=js&"
export * from "./integral-goods-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports